module.exports = __webpack_public_path__ + "static/media/hour.a10ff387.svg";